import { render, staticRenderFns } from "./AfterLoanCollateral.vue?vue&type=template&id=2fa25d93&"
import script from "./AfterLoanCollateral.vue?vue&type=script&lang=js&"
export * from "./AfterLoanCollateral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports